import React, { useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import * as RB from 'react-bootstrap'
import { personalInfoTranslate, wheelCollaboratorTranslate } from '../../../../i18n/translatedMessages'
import FormProfInfo from '../FormsInfo/FormProfInfo'

function formatDate(dateStr) {
	if (!dateStr) return ''
	const date = new Date(dateStr)
	return date.toLocaleDateString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' })
}

export const AccordionItem = ({ item, index, select = 0, onDelete, onUpdate, onClick, onChange, changed }) => {
	const { onSelect } = useContext(RB.AccordionContext)
	useEffect(() => onSelect(select), [select])

	const start = formatDate(item.startDate)
	const end = item.endDate ? formatDate(item.endDate) : null

	let title = ''
	if (item.id && item.currentJob) {
		title = `${item.job} em ${item.company} de ${start} até o momento`
	} else if (item.id && end) {
		title = `${item.job} em ${item.company} de ${start} até ${end}`
	} else if (item.id) {
		title = `${item.job} em ${item.company} de ${start}`
	} else {
		title = personalInfoTranslate.personalAddInfoProf
	}

	return (
		<RB.Accordion.Item className='shadow my-3' eventKey={index}>
			<RB.Accordion.Header>{title}</RB.Accordion.Header>
			<RB.Accordion.Body>
				<FormProfInfo
					data={item}
					index={index}
					deleteProfInfo={onDelete}
					updateProfInfo={onUpdate}
					handleChange={onChange}
					handleSend={onClick}
					changed={changed}
				/>
			</RB.Accordion.Body>
		</RB.Accordion.Item>
	)
}

AccordionItem.propTypes = {
	item: PropTypes.object,
	index: PropTypes.number,
	select: PropTypes.number,
	onDelete: PropTypes.func,
	onClick: PropTypes.func,
	onChange: PropTypes.func,
	onUpdate: PropTypes.func,
	changed: PropTypes.bool,
}
